import { otpCodeFieldName } from 'pages/profile/profile.config';
import { MapDataObjType } from './partials/OtpModalBody.types';

export const ERROR_OTP_GENERIC = 'err.generic.otp';
export const ERROR_OTP_USERBLOCKED = 'err.otp.block';
export const ERROR_OTP_NOTVALID = 'err.otp.codeNotValid';
export const ERROR_OTP_EXPIRED_SESSION = 'err.otp.expired.session';
export const ERROR_OTP_EXPIRED_WAIT = 'err.otp.codeExpiredWait';
export const ERROR_OTP_OUTLIMIT = 'err.out.limit';
export const ERROR_OTP_ALREADYSENT = 'err.otp.alreadySent';

export const analyticsPayload = {
  pagename: 'areaprivata:profilo:popup-otp',
};

if (!import.meta.env.PROD) {
  Object.freeze(analyticsPayload);
}

export type OtpFormValue = {
  [otpCodeFieldName]: string;
};

export const modalMapDataObjType: Record<
  'email' | 'phoneNumber',
  MapDataObjType
> = {
  email: {
    typeString: 'indirizzo email',
    subtitleWords: ' via <b>email</b> ',
  },
  phoneNumber: {
    typeString: 'numero di cellulare',
    subtitleWords: ' via <b>sms</b>',
  },
};
